// ═══════════════════════════════════════════════════════════════════════════════
// Membership / restore archived tasks (§22.7)
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
export const restoreArchivedTasksBodySchema = z.object({
    taskIds: z.array(uuidSchema).min(1).max(50),
});
//# sourceMappingURL=membership.schema.js.map